import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocalStorageService } from '../services/local-storage.service';
import { API_ROUTES, LOCALSTORAGE_TOKENS } from '../constants/injection-tokens';
import { LocalstorageTokensKeys } from '../../shared/models/tokens-keys.interface';
import { isAuthExceptionRoute } from './auth-exception-routes.const';

export const httpInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const localStorageService = inject(LocalStorageService);
  const apiRoutes = inject(API_ROUTES);
  const localstorageTokensKeys = inject<LocalstorageTokensKeys>(LOCALSTORAGE_TOKENS);

  if (isAuthExceptionRoute(request.url, apiRoutes)) {
    return next(request);
  }

  const token = localStorageService.getItem<string>(localstorageTokensKeys.accessToken);

  if (!token) {
    return next(request);
  }

  const authRequest = request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(authRequest);
};
